import { useEffect, useState } from "react";
import { ListingCard } from "@/components/ListingCard";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";

const PageHeader = ({ overline, title, subtitle }) => (
  <section className="bg-navy pt-36 pb-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal><p className="overline">{overline}</p></Reveal>
      <Reveal delay={0.05}>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-white mt-4 leading-tight">{title}</h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className="font-body text-white/70 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export function ListingsPage({ type = "featured", overline, title, subtitle, emptyText, seoTitle, seoDescription, seoPath }) {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/listings", { params: { property_type: type } })
      .then((r) => setListings(r.data))
      .catch(() => setListings([]))
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <div data-testid={`${type}-listings-page`}>
      <Seo title={seoTitle} description={seoDescription} path={seoPath} />
      <PageHeader overline={overline} title={title} subtitle={subtitle} />
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {loading ? (
            <p className="font-mono text-ink-soft text-sm">Loading listings…</p>
          ) : listings.length === 0 ? (
            <div className="border border-dashed border-navy/20 p-16 text-center">
              <p className="font-body text-ink-soft">{emptyText}</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {listings.map((l, i) => (
                <Reveal key={l.id} delay={(i % 3) * 0.08}><ListingCard listing={l} index={i} /></Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default function Listings() {
  return (
    <ListingsPage
      type="featured"
      overline="Current Opportunities"
      title="Featured Listings"
      subtitle="Active foreclosure and court-ordered properties personally represented by Mike Sidhu, Personal Real Estate Corporation, across the Lower Mainland."
      emptyText="No featured listings at the moment. Please check back soon or contact Mike directly."
      seoTitle="Featured Listings | Mike Sidhu, Personal Real Estate Corporation · RE/MAX Performance Realty"
      seoDescription="Browse active foreclosure and court-ordered listings across Surrey, Coquitlam, Burnaby and the Lower Mainland, personally represented by Mike Sidhu, Personal Real Estate Corporation."
      seoPath="/listings"
    />
  );
}
